<template>
	<div class="prog_reg-body theme-light">
		<div v-if="isInvoicePayment" class="container">
			<step3-pay-by-invoice
				:form-data="formData"
				:fields="formData.fields[3]"
			/>

			<div class="w-100">
				<a
					target="_blank"
					class="btn btn-primary mb-3 mr-2"
					href=""
					@click.prevent="isContractVisible = true"
				>
					Просмотреть договор оферты
				</a>
				<a
					v-if="isContractAgree"
					class="btn btn-primary mb-3"
					:href="invoiceUrl"
					@click.prevent="isInvoiceVisible = true"
				>
					Просмотреть счет
				</a>

				<div class="custom-control custom-checkbox mb-4">
					<input
						id="contract-agreement"
						v-model="isContractAgree"
						type="checkbox"
						name="contractAgreement"
						class="custom-control-input"
						data-action="checkout-offer-agreement"
					>
					<label
						class="custom-control-label"
						for="contract-agreement"
					>Согласен с условиями договора оферты*</label>
				</div>
				<!-- <div v-if="!isContractAgree" class="mb-4">
					<b-form-group id="example-input-group-1">
						<label for="example-input-group-1" class="d-block col-form-label-sm mb-2">
							Опишите, с чем вы не согласны, и мы рассмотрим заявку.
						</label>
						<b-form-textarea
							name="example-input-1"
							aria-describedby="input-1-live-feedback"
							@change="setDisagreementReason"
						/>
					</b-form-group>
				</div> -->

				<button
					v-if="!isContractAgree"
					class="btn btn-primary"
					@click.prevent="setContactManager(null)"
				>
					Отправить
				</button>
			</div>
		</div>
		<div v-if="!isInvoicePayment">
			<div class="container">
				<div class="title">
					Оплата
				</div>
				<div class="description">
					<p>Выберите удобный для вас способ оплаты</p>
				</div>
			</div>

			<div
				v-if="
					!formData.disable_payment_until_chek_documents ||
						getOrderSatus(formData.id) == 1
				"
				class="person-choise"
			>
				<div class="container">
					<div class="row">
						<div class="col-12 col-md-6 col-lg-6 mb-4">
							<div class="card payment-card">
								<div class="row justify-content-center h-100">
									<div
										class="col-11 col-sm-10 d-flex flex-column justify-content-between align-items-start"
									>
										<div class="w-100">
											<div
												class="d-flex align-items-center"
											>
												<div
													class="card-icon icon-pay_card"
												/>
												<div class="title ml-3">
													Online платеж
												</div>
											</div>

											<div class="content-box">
												<div
													class="small disclaimer alert theme-darkgray"
													role="alert"
												>
													<span class="icon-exclam" />
													Сумма платежа не может
													составлять более 600000
													рублей на всех участников
												</div>
												<b-dropdown
													:id="'payment_type_dropdown'"
													block
													variant="secondary-outer"
													menu-class="w-100"
													@click.native="
														setPaymentMethodDropdownText(
															$event.target
														)
													"
												>
													<template
														v-if="!selectedItem"
														#button-content
														class="rounded-0"
													>
														{{
															$t(
																'choosePaymentMethod',
															)
														}}
													</template>
													<template
														v-else
														#button-content
														class="rounded-0"
													>
														{{ selectedItem }}
													</template>

													<!--													<b-dropdown-item-button-->
													<!--														type="button"-->
													<!--														name="action"-->
													<!--														:class="{-->
													<!--															active:-->
													<!--																paymentProvider ===-->
													<!--																'qr' &&-->
													<!--																paymentMethod ===-->
													<!--																'qr',-->
													<!--														}"-->
													<!--														@click="-->
													<!--															selectPaymentProvider(-->
													<!--																'qr'-->
													<!--															),-->
													<!--															selectPaymentMethod(-->
													<!--																'qr'-->
													<!--															)-->
													<!--														"-->
													<!--													>-->
													<!--														<span-->
													<!--															class="icon icon-sberbank"-->
													<!--														>-->
													<!--															Оплата по QR-->
													<!--															коду-->
													<!--														</span>-->
													<!--													</b-dropdown-item-button>-->

													<b-dropdown-item-button
														type="button"
														name="action"
														:class="{
															active:
																paymentProvider ===
																'yandex' &&
																paymentMethod ===
																'sbp',
														}"
														@click="
															selectPaymentProvider(
																'yandex'
															),
															selectPaymentMethod(
																'sbp'
															)
														"
													>
														<span
															class="icon icon-sbp"
														>Система быстрых
															платежей</span>
													</b-dropdown-item-button>
													<b-dropdown-item-button
														type="button"
														name="action"
														:class="{
															active:
																paymentProvider ===
																'yandex' &&
																paymentMethod ===
																'bank_card',
														}"
														@click="
															selectPaymentProvider(
																'yandex'
															),
															selectPaymentMethod(
																'bank_card'
															)
														"
													>
														<span
															class="icon icon-credit_card"
														>Банковская
															карта</span>
													</b-dropdown-item-button>
													<b-dropdown-item-button
														v-if="
															formData.is_loan_possible
														"
														type="button"
														name="action"
														:class="{
															active:
																paymentProvider ===
																'tinkoff_loan_applications' &&
																paymentMethod ===
																'loan_application',
														}"
														@click="
															selectPaymentProvider(
																'tinkoff_loan_applications'
															),
															selectPaymentMethod(
																'loan_application'
															)
														"
													>
														<span
															class="icon icon-tinkoff"
														>Заявка на
															рассрочку</span>
													</b-dropdown-item-button>
												</b-dropdown>
												<dropdown-payment
													v-if="
														paymentProvider ===
															'tinkoff_loan_applications' &&
															paymentMethod ===
															'loan_application'
													"
													ref="dropdownPayment"
													:form-data="formData"
													:event-payment="event"
													@blur="onBlur"
												/>
												<b-form-invalid-feedback
													:state="
														paymentValid(
															'paymentMethod'
														)
													"
												>
													<div
														v-for="msg in paymentForm
															.errors[
																'paymentMethod'
															]"
														:key="msg"
													>
														{{ msg }}
													</div>
												</b-form-invalid-feedback>
											</div>
										</div>
										<div class="w-100">
											<template
												v-if="
													paymentProvider ===
														'tinkoff_loan_applications'
												"
											>
												<div
													class="custom-control custom-checkbox mb-3"
												>
													<input
														id="contract-agreement"
														v-model="
															isContractAgree
														"
														type="checkbox"
														name="contractAgreement"
														class="custom-control-input"
														data-action="checkout-offer-and-credit-agreement"
													>
													<label
														class="custom-control-label mt-3"
														for="contract-agreement"
													>
														Согласен с
														<a
															target="_blank"
															href="/pdf/offer_education.pdf"
														>договором оферты и
															с условием о
															кредите</a>
													</label>
												</div>
												<!-- <div v-if="!isContractAgree" class="mb-3">
													<b-form-group id="example-input-group-1">
														<label class="d-block col-form-label-sm mb-2">
															Опишите, с чем вы не согласны, и мы рассмотрим заявку.
														</label>
														<b-form-textarea
															name="example-input-1"
															aria-describedby="input-1-live-feedback"
															@change="setDisagreementReason"
														/>
													</b-form-group>
												</div> -->
											</template>
											<template v-else>
												<div
													class="custom-control custom-checkbox mb-3"
												>
													<input
														id="contract-agreement"
														v-model="
															isContractAgree
														"
														type="checkbox"
														name="contractAgreement"
														class="custom-control-input"
														data-action="checkout-offer-agreement"
													>
													<label
														class="custom-control-label"
														for="contract-agreement"
													>Соглашаюсь с условиями
														<a
															role="button"
															class="text-primary"
															@click.prevent="
																isContractVisible = true
															"
														>договора оферты</a>
													</label>
												</div>
												<!-- <div v-if="!isContractAgree" class="mb-3">
													<b-form-group id="example-input-group-1">
														<label for="example-input-group-1" class="d-block col-form-label-sm mb-2">
															Опишите, с чем вы не согласны, и мы рассмотрим заявку.
														</label>
														<b-form-textarea
															name="example-input-1"
															aria-describedby="input-1-live-feedback"
															@change="setDisagreementReason"
														/>
													</b-form-group>
												</div> -->
											</template>
											<div
												v-if="showPersonalData"
												class="custom-control custom-checkbox mb-3"
											>
												<input
													id="personal-data-agreement-cs3"
													v-model="
														agreements.personal_data
													"
													type="checkbox"
													name="personalDataAgreement"
													class="custom-control-input"
													data-action="checkout-personal-data-agreement"
												>
												<label
													class="custom-control-label"
													for="personal-data-agreement-cs3"
												>Соглашаюсь на
													<a
														target="_blank"
														class="text-primary"
														href="https://www.skolkovo.ru/static/personaldata_rus.html"
													>обработку моих
														персональных данных</a>
												</label>
												<!-- <label
													v-if="!$v.agreements.personal_data.checked"
													class="error"
													for="personal-data-agreement"
												>Пожалуйста, подтвердите согласие на обработку персональных данных</label> -->
											</div>
											<div v-if="showMarketingEmails" class="custom-control custom-checkbox mb-3">
												<input
													id="marketing-emails-agreement-cs3"
													v-model="agreements.marketing_emails"
													type="checkbox"
													name="marketingEmailsAgreement"
													class="custom-control-input"
													data-action="checkout-marketing-emails-agreement"
												>
												<label
													class="custom-control-label"
													for="marketing-emails-agreement-cs3"
												>{{ $t('isAgreesToMarketingEmails') }}</label>
											</div>
											<div
												v-if="
													$auth.user?.loyalty_id && isUserPhoneVerified && !isFetching
												"
											>
												<b-form-checkbox
													v-model="charge_points"
													switch
													:value="1"
													:unchecked-value="0"
												>
													Оплатить баллами программы
													лояльности
												</b-form-checkbox>
												<label
													v-if="charge_points"
													for="loyalty_points_to_charge"
												>
													Выберите количество баллов
													для списания.
												</label>
												<b-form-input
													v-if="
														$auth.user &&
															$auth.user.loyalty_id &&
															max_charge_points > 0 &&
															charge_points
													"
													id="loyalty_points_to_charge"
													v-model="
														loyalty_points_to_charge
													"
													type="range"
													label="Выберите количество баллов для списания"
													min="0"
													:max="max_charge_points"
												/>
												<small>Доступно:
													{{
														max_charge_points
													}}
													баллов.</small>
												<div
													v-if="charge_points"
													class="mt-2"
												>
													Будет списано:
													{{
														loyalty_points_to_charge
													}}
													баллов.
												</div>
												<div v-if="charge_points">
													Итоговая стоимость после
													списания баллов:
													<strong>{{
														price -
															loyalty_points_to_charge
													}}
														рублей</strong>
												</div>
											</div>
											<p v-if="$auth.user?.loyalty_id && !isUserPhoneVerified && !isFetching">
												Для того, чтобы списать баллы, пожалуйста, подтвердите номер телефона в
												<nuxt-link to="/user/profile/loyalty/card/">
													личном кабинете
												</nuxt-link>.
											</p>
											<div class="buttons mt-2">
												<template
													v-if="isContractAgree"
												>
													<button
														v-if="
															paymentMethod !==
																'loan_application'
														"
														class="btn btn-primary"
														:disabled="
															paymentForm.sending
														"
														@click.prevent="
															doOnlinePayment
														"
													>
														<b-spinner
															v-if="
																paymentForm.sending
															"
															style="
																width: 1.3em;
																height: 1.3em;
																margin-right: 15px;
															"
														/>
														Перейти к оплате
													</button>
													<button
														v-else-if="
															formData.is_loan_possible
														"
														class="btn btn-secondary-outer loan"
														@click.prevent="
															createLoanApplication
														"
													>
														<b-spinner
															v-if="
																paymentForm.sending
															"
															style="
																width: 1.3em;
																height: 1.3em;
																margin-right: 15px;
															"
														/>
														Заявка на рассрочку
													</button>
												</template>
												<button
													v-else
													class="btn btn-primary"
													@click.prevent="
														setContactManager(null)
													"
												>
													Отправить
												</button>
											</div>
										</div>
									</div>
									<b-container
										v-if="
											!paymentForm.sending &&
												paymentForm.error
										"
										class="d-flex justify-content-center"
									>
										<b-alert
											variant="danger"
											show
											class="mt-3 mb-3"
										>
											{{ paymentForm.error }}
										</b-alert>
									</b-container>
									<b-container
										v-if="
											!paymentForm.sending &&
												paymentForm.attempted &&
												!$v.agreements.personal_data.checked
										"
										class="d-flex justify-content-center"
									>
										<b-alert
											variant="danger"
											show
											class="mt-3 mb-3"
										>
											Нужно ваше согласие на обработку
											персональных данных
										</b-alert>
									</b-container>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-6 mb-4">
							<div class="card payment-card">
								<div class="row justify-content-center h-100">
									<div
										class="col-11 col-sm-10 d-flex flex-column justify-content-between align-items-start"
									>
										<div class="w-100">
											<!-- <div class="card-icon icon-pay_transfer title">
												Оплата по счёту
											</div> -->
											<div
												class="d-flex align-items-center"
											>
												<div
													class="card-icon icon-pay_transfer"
												/>
												<div class="title ml-3">
													Оплата по счёту
												</div>
											</div>

											<div class="content-box">
												<div
													class="small disclaimer alert theme-darkgray"
													role="alert"
												>
													<span class="icon-exclam" />
													Выбирая способ платежа
													"Оплата по счёту", вам будет
													необходимо ввести реквизиты
													для юридического лица, или
													данные регистрации для
													физического лица
												</div>
												<div class="content">
													<div class="h6">
														Выберите тип контрагента
													</div>
													<div
														class="custom-control custom-radio mb-1"
													>
														<input
															id="customRadio1"
															:checked="
																getScenario(
																	formData.id
																) === 1
															"
															type="radio"
															name="customRadio"
															class="custom-control-input"
															@click="
																changeLegalStatus(
																	1
																)
															"
														>
														<label
															class="custom-control-label"
															for="customRadio1"
														>Физическое
															лицо</label>
													</div>
													<div
														class="custom-control custom-radio"
													>
														<input
															id="customRadio2"
															:checked="
																getScenario(
																	formData.id
																) === 2
															"
															class="custom-control-input"
															type="radio"
															name="customRadio"
															@click="
																changeLegalStatus(
																	2
																)
															"
														>
														<label
															class="custom-control-label"
															for="customRadio2"
														>Юридическое
															лицо</label>
													</div>
												</div>
											</div>
										</div>
										<div class="w-100">
											<button
												type="button"
												class="btn btn-primary"
												:disabled="
													getScenario(formData.id) ===
														0 ||
														getScenario(formData.id) ===
														null
												"
												@click="
													setLocalIsInvoicePayment(
														true
													)
												"
											>
												Создать счет
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-else class="row">
				<div class="col-12 col-md-12 mb-2">
					<div
						class="pt-4 pb-2 disclaimer alert text-center theme-darkgray"
					>
						<p>
							Спасибо! Ваша заявка принята. После успешной
							проверки документов у вас появится возможность
							оплаты.
						</p>
					</div>
				</div>
			</div>
		</div>
		<contract-popup
			:value="isContractVisible"
			:form-id="formData.id"
			@close="isContractVisible = false"
		/>
		<invoice-popup
			:value="isInvoiceVisible"
			:form-id="formData.id"
			:order-id="orderId"
			@close="isInvoiceVisible = false"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';

import {
	CHECKOUT_STORE_NAMESPACE,
	ACTION_SAVE_ORDER,
	ACTION_SAVE_FORM_DATA_BACKEND,
	MUTATION_SET_FORM_META_DATA,
} from '~/store/checkout';

import { CONTACT_MANAGER_DO_NOT_WANT_PAYMENT_REASON } from '~/components/checkout/contactManagerReasonDictionary';

import checkoutForm from '~/mixins/checkoutForm';
import checkoutFormStep from '~/mixins/checkoutFormStep';
import checkMobile from '~/mixins/checkMobile';
import agreementsMixin from '~/mixins/agreementsMixin';
import ContractPopup from '~/components/ContractPopup.vue';
import InvoicePopup from '~/components/checkout/InvoicePopup.vue';
import Step3PayByInvoice from '~/components/checkout/Step3PayByInvoice.vue';
import DropdownPayment from './fields/DropdownPayment.vue';

export default {
	name: 'CheckoutStep3',
	components: {
		InvoicePopup,
		Step3PayByInvoice,
		ContractPopup,
		DropdownPayment,
	},
	mixins: [
		validationMixin,
		checkoutFormStep,
		checkoutForm,
		checkMobile,
		agreementsMixin,
	],
	props: {
		formData: { type: Object, required: true },
	},
	validations() {
		return {
			agreements: this.agreements_validation,
		};
	},
	data() {
		return {
			paymentForm: {
				attempted: false,
				sending: false,
				message: null,
				errors: {},
			},
			selectedItem: '',
			collapseCardId: 'collapse-card_1',
			paymentProvider: null,
			paymentMethod: null,
			paymentMethodText: 'Выберите способ оплаты',
			baseApiUrl: process.env.BASE_API_URL,
			isContractAgree: true,
			isContractVisible: false,
			isInvoiceVisible: false,
			CONTACT_MANAGER_DO_NOT_WANT_PAYMENT_REASON,
			loanPromoCode: '',
			loanPromoCodeText: 'Период и ставка рассрочки',
			loanPromoCodes: [
				{ value: 'installment_0_0_3_6,0', text: '3 месяца' },
				{ value: 'installment_0_0_4_7,5', text: '4 месяца' },
				{ value: 'installment_0_0_6_10,2', text: '6 месяцев' },
				{ value: 'installment_0_0_10_15,5', text: '10 месяцев' },
				{ value: 'installment_0_0_12_18', text: '12 месяцев' },
				{ value: 'installment_0_0_15_21,5', text: '15 месяцев' },
				{ value: 'installment_0_0_18_24,7', text: '18 месяцев' },
				{ value: 'installment_0_0_24_31', text: '24 месяца' },
				{ value: 'installment_0_0_30_36', text: '30 месяцев' },
				{ value: 'installment_0_0_36_41', text: '36 месяцев' },
			],
			loyalty_points_to_charge: 0,
			max_charge_points: 0,
			charge_points: 0,
			isFetching: false,
			isUserPhoneVerified: false,
		};
	},
	computed: {
		...mapGetters({
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getStep: 'checkout/getStep',
			getIsShowPaymentPopup: 'checkout/getIsShowPaymentPopup',
			getOrderId: 'checkout/getOrderId',
			getOrderSatus: 'checkout/getOrderSatus',
		}),
		orderId() {
			return this.getOrderId(this.formData.id);
		},
		count() {
			return Object.keys(this.$store.state.checkout.formsData.fields)
				.length;
		},
		price() {
			return parseFloat(this.product.price);
		},
		invoiceUrl() {
			const uuid = this.$store.state.uniqueId.uniqueId;
			const formId = this.formData.id;
			return `${this.baseApiUrl}/api/checkout/invoice?uuid=${uuid}&formId=${formId}`;
		},
	},
	watch: {
		$v: {
			handler() {
				this.paymentForm.attempted = false;
			},
			deep: true,
		},
		isContractAgree() {
			this.paymentForm.attempted = false;
		},
	},
	mounted() {
		if (this.priceData.individualPriceWithDiscount === 0) {
			this.setContactManager(CONTACT_MANAGER_DO_NOT_WANT_PAYMENT_REASON);
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						showPaymentPopup: false,
					},
					formId: this.formData.id,
				},
			);
			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);
		} else if (
			this.getIsShowPaymentPopup(this.formData.id)
			&& !this.formData.disable_payment_until_chek_documents
		) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						showPaymentPopup: false,
					},
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);
		}
		this.getIsVerifiedPhone();
		this.getMaxPointsToCharge(this.price);
	},
	methods: {
		paymentValid(field) {
			if (this.paymentForm.errors[field] === undefined) return null;
			return !this.paymentForm.errors[field];
		},
		changeLegalStatus(value) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: { scenario: value },
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{
					formId: this.formData.id,
				},
			);
		},
		selectPaymentMethod(paymentMethod) {
			this.paymentMethod = paymentMethod;
		},
		selectPaymentProvider(paymentProvider) {
			this.paymentProvider = paymentProvider;
		},
		setPaymentMethodDropdownText(target) {
			this.paymentMethodText = target.innerHTML;
			this.selectedItem = target.textContent;
		},
		async doOnlinePayment() {
			this.paymentForm.sending = true;
			this.paymentForm.error = null;
			this.paymentForm.errors = {};

			this.$v.$touch();
			this.$nextTick(() => {
				this.paymentForm.attempted = true;
			});
			if (this.$v.$invalid) {
				this.paymentForm.sending = false;
				return;
			}

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_ORDER}`,
				{
					formId: this.formData.id,
				},
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);

			try {
				const response = await this.$api.doOnlinePayment({
					paymentProvider: 'yandex',
					paymentMethod: this.paymentMethod,
					formId: this.formData.id,
					eventId: this.event.id,
					uniqueId: this.$store.state.uniqueId.uniqueId,
					loyalty_points_to_charge: this.loyalty_points_to_charge,
					charge_points: this.charge_points,
				});

				this.setAgreementFields();
				window.location.href = response.payment_url;
			} catch (error) {
				try {
					const { message, errors } = this.$api.getValidationFromError(error);
					this.paymentForm.error = message;
					this.paymentForm.errors = errors;
				} catch {
					this.$logger.log(error);
					this.paymentForm.error = 'Что-то пошло не так';
					this.paymentForm.errors = {};
				}
			} finally {
				this.paymentForm.sending = false;
			}
		},
		setDisagreementReason(value) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						disagreementReason: value,
					},
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);
		},
		async createLoanApplication() {
			this.paymentForm.sending = true;
			this.paymentForm.error = null;
			this.paymentForm.errors = {};

			this.$v.$touch();
			this.$nextTick(() => {
				this.paymentForm.attempted = true;
			});
			if (this.$v.$invalid) {
				this.paymentForm.sending = false;
				return;
			}

			try {
				await this.$store.commit(
					`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
					{
						meta: { step: 4 },
						formId: this.formData.id,
					},
				);
			} catch (error) {
				try {
					const { message, errors } = this.$api.getValidationFromError(error);
					this.paymentForm.error = message;
					this.paymentForm.errors = errors;
				} catch {
					this.$logger.log(error);
					this.paymentForm.error = 'Что-то пошло не так';
					this.paymentForm.errors = {};
				}
			} finally {
				this.paymentForm.sending = false;
			}
		},
		async getMaxPointsToCharge(productAmount) {
			if (this.$auth.user) {
				this.max_charge_points = (
					await this.$api.getLoyaltyMaxPointsToCharge(productAmount)
				).max_points;
			}
		},
		async getIsVerifiedPhone() {
			try {
				this.isFetching = true;
				const res = await this.$api.getIsVerifiedPhone();
				this.isUserPhoneVerified = res.status;
			} finally {
				this.isFetching = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/prog-registration";

.prog_registration .payment-card {
	text-align: left !important;
}

.prog_registration .form-control,
.prog_registration .custom-select {
	border-width: 1px;
}

.buttons {
	display: flex;
	flex-direction: column;
	@include media-breakpoint-up(lg) {
		flex-direction: row;
	}

	.loan {
		margin-left: 0;
		margin-bottom: 10px;

		@include media-breakpoint-up(lg) {
			margin-left: 10px;
			margin-bottom: 0;
		}
	}
}
</style>
